import PanToolIcon from '@mui/icons-material/PanTool';
import PhonelinkEraseRounded from '@mui/icons-material/PhonelinkEraseRounded';
import { Box, Typography } from "@mui/material";
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { useGlobal } from '../GlobalProviderLayout';
import { CLOSE_TOAST } from '../GlobalProviderLayout/GlobalProviderLayoutModel';
import { AnonUnauthorizedError } from './AnonUnauthorizedError';
import { GenericError } from './GenericError';
import { iconStyle } from './styled';


/**
 * ErrorElement handles errors that bubble up from application/page routes (anything below RootLayout). 
 * It will handle loader/action errors including such as unhandled, authorization and version rrors. 
 * It will also present the general error if no specific error applies
 */
export const ErrorElement = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const auth = useAuth();
  const global = useGlobal();
  console.error(error)
  let status = isRouteErrorResponse(error) ? error.status : null;

  useEffect(() => {
    if (global.state.toast.open) {
      global.dispatch({ type: CLOSE_TOAST });
    }
  }, [global]);

  if (status === 403 && auth?.user?.profile?.authenticationMethod === "IVR") {
    return <GenericError
      icon={<PanToolIcon sx={iconStyle} />}
      header={"You are not authorized to perform this action"}
      subText={<>
        <Typography color={'red'}>
          We noticed you signed in using your IVR password which will only give you access to the DOA page
        </Typography>
        <Typography color={'red'}>
          If you would like to access this page, please sign back in using your MyBCMEA password.
        </Typography>
      </>}
    />
  }
  if (status === 403) {
    return <GenericError
      icon={<PanToolIcon sx={iconStyle} />}
      header={"You are not authorized to perform this action"}
      button={"Go to Home Page"}
      onButton={() => navigate("/")}
    />
  }
  if (status === 401) {
    return <AnonUnauthorizedError />
  }
  if (status === 426) {
    return <GenericError
      icon={
        <Box sx={iconStyle}>
          <img 
            src='/assets/images/BCMEA Icon Set Deep Blue_Dispatch.png' 
            height={64}
            width={64}
            alt='Deep Blue Dispatch' 
          />
        </Box>
      }
      header={"MyBCMEA has been updated"}
      subText={"Press the Refresh button to see the changes"}
      button={"Refresh"}
      onButton={() => navigate(0)}
    />
  }
  return <GenericError
    icon={<PhonelinkEraseRounded sx={iconStyle} />}
    header={"Error loading the page!"}
    subText={"Please try again"}
    button={"Retry"}
    onButton={() => navigate(0)}
  />
};
